
export const ROUTES = {
    main: "/",
    home: "/home",

    // Auth
    login: "/login",
    register: "/register",
    verifyEmail: "/verify-email",
    forgotPassword: "/forgot-password",
    changePassword: "/change-password",

    // Main
    profile: "/profile",

    // Worker
    onboarding: "/onboarding",
    jobDetail: "/home/:jobId",
    assignments: "/assignments",
    assignmentDetail: "/assignments/:assignmentId",

    // Admin
    admin: "/admin",
    adminWorkers: "/admin/workers",

    // Docs
    apiDocs: "/docs/api",

    notFound: "*",
};

export const API_ROUTES = {
    // Auth
    login: "/auth/login/",
    logout: "/auth/logout/",
    refresh: "/auth/token/refresh/",
    signup: "/auth/registration/",
    resendEmail: "/resend-email-confirmation/",
    confirmEmail: "/auth/registration/account-confirm-email/",
    changePassword: "/auth/password/change/",
    resetPassword: "/auth/password/reset/",
    resetPasswordConfirm: "/auth/password/reset/confirm/",
    googleLogin: "/auth/google/",

    // Other
    profile: "/api/auth/profile/",

    // Worker
    workerMe: "/api/v1/worker/me/",
    workerFeed: "/api/v1/worker/feed/",
    workerJobDetail: (uuid: string) => `/api/v1/worker/feed/${uuid}/`,
    workerClaimJob: (uuid: string) => `/api/v1/worker/feed/${uuid}/claim/`,
    workerAssignments: "/api/v1/worker/assignments/",
    workerAssignmentDetail: (uuid: string) => `/api/v1/worker/assignments/${uuid}/`,
    workerSubmitAssignment: (uuid: string) => `/api/v1/worker/assignments/${uuid}/submit/`,
    workerTransactions: "/api/v1/worker/transactions/",
    workerUploadUrl: "/api/v1/worker/upload-url/",

    // Professions
    professions: "/api/v1/professions/",

    // Admin
    adminWorkers: "/api/v1/admin/workers/",
    adminWorkerDetail: (uuid: string) => `/api/v1/admin/workers/${uuid}/`,
    adminApproveWorker: (uuid: string) => `/api/v1/admin/workers/${uuid}/approve/`,
    adminSuspendWorker: (uuid: string) => `/api/v1/admin/workers/${uuid}/suspend/`,
    adminSetProfessions: (uuid: string) => `/api/v1/admin/workers/${uuid}/professions/`,
    adminProfessions: "/api/v1/admin/professions/",
}

// Only these paths dont require to send a token
// See /lib/axios.ts
export const NO_AUTH_REQUIRED_API_ROUTES = [
    API_ROUTES.login,
    API_ROUTES.refresh,
    API_ROUTES.signup,
    API_ROUTES.resendEmail,
    API_ROUTES.confirmEmail,
    API_ROUTES.resetPassword,
    API_ROUTES.resetPasswordConfirm,
    API_ROUTES.googleLogin,
]